import * as firebase from 'firebase/app';
import 'firebase/auth';

class User {
  email: string;
  loggedIn: boolean;
  verified: boolean;
  admin: 'disabled' | 'user' | 'power' | 'admin';

  constructor(fbuser: FirebaseUser) {
    const { email, admin, loggedIn, verified } = fbuser;
    this.email = email;
    this.admin = admin;
    this.loggedIn = loggedIn;
    this.verified = verified;
  }

  logOut() {
    firebase.auth().signOut();
  }
}

export default User;
